
import React from 'react';
import RestaurantOutlinedIcon from '@mui/icons-material/RestaurantOutlined';
import HotelOutlinedIcon from '@mui/icons-material/HotelOutlined';
import FlightOutlinedIcon from '@mui/icons-material/FlightOutlined';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';

/** Matches Add-place search result rows (PlaceSearchResultCard). */
export const PLACE_SEARCH_ROW_ICON_SX = { fontSize: 20, color: '#252528' } as const;

export type PlaceSearchRowSlotKind = 'eat' | 'stay' | 'do' | 'flight';

export function PlaceSearchRowTypeIcon({
  kind,
  color,
}: {
  kind: PlaceSearchRowSlotKind;
  /** Override the icon color (defaults to PLACE_SEARCH_ROW_ICON_SX color). */
  color?: string;
}): React.ReactElement {
  const sx = color ? { ...PLACE_SEARCH_ROW_ICON_SX, color } : PLACE_SEARCH_ROW_ICON_SX;
  switch (kind) {
    case 'eat':
      return <RestaurantOutlinedIcon sx={sx} aria-hidden />;
    case 'stay':
      return <HotelOutlinedIcon sx={sx} aria-hidden />;
    case 'flight':
      return <FlightOutlinedIcon sx={sx} aria-hidden />;
    default:
      return <PlaceOutlinedIcon sx={sx} aria-hidden />;
  }
}
